import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HistoryLogSidePanelComponent } from "./container/history-log-side-panel.component";

const routes: Routes = [
	{
		path: "",
		component: HistoryLogSidePanelComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class HistoryLogSidePanelRoutingModule {}
